import { classNames } from "@opensea/ui-kit"

export const expandedSearchTransitionClassNames = classNames(
  "transition duration-300 ease-out-quint",
)

export const expandedSearchHoverStyles = classNames(
  "hover:bg-bg-additional-2 border-border-1 hover:border-border-2 transition-colors duration-150 ease-out cursor-pointer",
)

export const expandedSearchSelectedStyles = classNames(
  "bg-bg-additional-2 border-border-2",
)
